import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAction = <T extends (...args: any) => ReturnType<T>>(action: T) => {
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useCallback((...args: Parameters<T>) => dispatch(action(...(args as any))), [dispatch, action]);
};
